import { postReqAuth } from '../../api';

export const getResultSheet = (data, cb) => postReqAuth('/webapi/student/exam/get/result-sheet/', data, '', cb);

export const getMyExamPerformance = (data, cb) =>
	postReqAuth("/webapi/student/exam/get/exam-performance/", data, "", cb);
